import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
// import '@/assets/fonts/SourceHanSans.css'
import { DatePicker, Select, Option, Table, TableColumn, Pagination, Popover, Message, Dialog, CheckboxGroup, MessageBox, Checkbox, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';

Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.prototype.$message = Message
Vue.prototype.$messageBox = MessageBox

axios('config.json').then(res=>{
  Vue.prototype.$baseURL = res.data.baseURL
  Vue.prototype.$identity = res.data.identity
},err=>{Message({message:'读取JSON文件失败，baseURL已更改为默认地址',type:'error'});Vue.prototype.$baseURL ='https://drawyourswoosh.nike.com.cn'})

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
